import dayjs, { Dayjs } from 'dayjs';

export class CreatePaymentFormValues {
  dealId: string = '';
  paymentTypeId: string = '';
  number: string = '';
  date: Dayjs | null = dayjs();
  amount: string = '';
  payerTin: string = '';
  payerName: string = '';
  recipientTin: string = '';
  recipientName: string = '';
  recipientAccount: string = '';
}
